import { Users, Video } from 'lucide-react';

import { MenuItem } from '@/components/utils/types';
import Dashboard from '@/components/icons/Dashboard';
import Mentors from '@/components/icons/Mentors';
import GroupMentoring from '@/components/icons/GroupMentoring';
import Community from '@/components/icons/Community';
import Events from '@/components/icons/Events';
import FAQ from '@/components/icons/FAQ';
import EmailSupport from '@/components/icons/EmailSupport';
import ReportDispute from '@/components/icons/ReportDispute';

// All commented routes below are for menu items that have been temporarily removed and will be potentially added back in the future.

// import Messages from '@/components/icons/Messages';
// import HelpUs from '@/components/icons/HelpUs';
// import FinancialDashboard from '@/components/icons/FinancialDashboard';
// import Courses from '@/components/icons/Courses';
// import Jobs from '@/components/icons/Jobs';

import { copy } from './copy';

const mentor = 'mentor';
const mentee = 'mentee';

export const mentorMenuItems: MenuItem[] = [
  {
    icon: <Dashboard />,
    label: 'Dashboard',
    route: `/dashboard/${mentor}`,
  },
  {
    icon: <GroupMentoring />,
    label: 'Mentoring Packages',
    route: '#',
    children: [
      {
        label: 'My Mentoring Packages',
        route: '/mentor/mentoring-packages',
      },
      {
        label: 'Create New Package',
        route: '/mentor/mentoring-packages/new',
      },
    ],
  },
  {
    icon: <GroupMentoring />,
    label: 'Upcoming Mentoring Sessions',
    route: '/mentor/upcoming-mentoring-sessions',
  },
  {
    icon: <Community />,
    label: 'Mentees',
    route: '#',
    children: [
      {
        label: 'My Current Paid Mentees',
        route: '/mentor/paid-mentees',
      },
      {
        label: 'My Connected Mentees',
        route: '/mentor/connected-mentees',
      },
      {
        label: 'Recommended Mentees',
        route: '/mentor/recommended-mentees',
      },
      {
        label: 'Search Mentees',
        route: '/mentor/search-mentees',
      },
    ],
  },
  {
    icon: <Events />,
    label: 'My Mentoring Calendar',
    route: '#',
    children: [
      {
        label: 'Mentoring Calendar',
        route: '/mentor/mentoring-calendar',
      },
      {
        label: 'Set Available Timeslots',
        route: '/mentor/profile/availability',
      },
    ],
  },
  {
    icon: <GroupMentoring />,
    label: 'Group Mentoring Cohorts',
    route: '#',
    children: [
      {
        label: 'My Group Cohorts',
        route: '/mentor/group-mentoring-cohorts',
      },
      {
        label: 'Create New Group Cohort',
        route: '/mentor/group-mentoring-cohorts/new',
      },
    ],
  },
  // {
  //   icon: <FinancialDashboard />,
  //   label: 'Financial Dashboard',
  //   route: '/mentor/financial-dashboard',
  // },
];

export const menteeMenuItems: MenuItem[] = [
  {
    icon: <Dashboard />,
    label: 'Dashboard',
    route: `/dashboard/${mentee}`,
  },
  {
    icon: <Mentors />,
    label: 'Mentors',
    route: '#',
    children: [
      {
        label: 'My Current Mentors',
        route: '/mentee/current-mentors',
      },
      {
        label: 'Connected Mentors',
        route: '/mentee/connected-mentors',
      },
      {
        label: 'Pending Mentorship Connection Requests',
        route: '/mentee/pending-requests',
      },
      {
        label: 'Recommended Mentors',
        route: '/mentee/recommended-mentors',
      },
      {
        label: 'Search Mentors',
        route: '/mentee/search-mentors',
      },
    ],
  },
  {
    icon: <GroupMentoring />,
    label: 'Group Mentoring Cohorts',
    route: '#',
    children: [
      {
        label: 'Upcoming Group Cohorts',
        route: '/mentee/upcoming-group-cohorts',
      },
      {
        label: 'Completed Cohorts',
        route: '/mentee/completed-group-cohorts',
      },
      {
        label: 'Joined Cohorts',
        route: '/mentee/joined-group-cohorts',
      },
      {
        label: 'Search Group Cohorts',
        route: '/mentee/search-group-cohorts',
      },
    ],
  },
  // {
  //   icon: <Community />,
  //   label: 'Community',
  //   route: '/mentee/community',
  // },
  // {
  //   icon: <Courses />,
  //   label: 'Courses',
  //   route: '/mentee/courses',
  // },
  // {
  //   icon: <Jobs />,
  //   label: 'Jobs',
  //   route: '/mentee/job-board',
  // },
];

export const commonMenuItemsGroup: MenuItem[] = [
  // {
  //   icon: <Messages />,
  //   label: 'Messages',
  //   route: '/messages',
  // },
  // {
  //   icon: <Events />,
  //   label: 'Events',
  //   route: '/events',
  // },
  {
    icon: <FAQ />,
    label: 'Frequently Asked Questions',
    route: '/faq',
  },
  // {
  //   icon: <HelpUs />,
  //   label: 'Help Us Improve',
  //   route: '/help-us-to-improve',
  // },
  {
    icon: <EmailSupport />,
    label: 'Email Support',
    route: '/contact-us',
  },
  {
    icon: <ReportDispute />,
    label: 'Report Dispute',
    route: '/report-dispute',
  },
];

export const adminMenuItems: MenuItem[] = [
  {
    icon: <Dashboard />,
    label: 'Dashboard',
    route: '/admin',
  },
  {
    icon: <Users />,
    label: 'Manage Mentors',
    route: '/admin/manage-mentors',
  },
  {
    icon: <Users />,
    label: 'Manage Mentees',
    route: '/admin/manage-mentees',
  },
  {
    icon: <Video />,
    label: 'Meeting Room',
    route: '/admin/meeting-room',
  },
];

const myProfilePrefix = 'My Profile';

export const commonInternalRoutes: MenuItem[] = [
  {
    label: `${myProfilePrefix}`,
    route: `/${mentor}/profile`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.mentorshipPreferences}`,
    route: `/${mentor}/profile/mentorship-preferences`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.personalInformation}`,
    route: `/${mentor}/profile/personal-information`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.professionalBackground}`,
    route: `/${mentor}/profile/professional-background`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.cv}`,
    route: `/${mentor}/profile/cv`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.paymentDetails}`,
    route: `/${mentor}/profile/payment-details`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.mentoringContractWithBWBN}`,
    route: `/${mentor}/profile/mentoring-contract-with-bwbn`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.availability}`,
    route: `/${mentor}/profile/availability`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.meetingSettings}`,
    route: `/${mentor}/profile/meeting-settings`,
  },
  {
    label: `${myProfilePrefix}`,
    route: `/${mentee}/profile`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.personalInformation}`,
    route: `/${mentee}/profile/personal-information`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.mentorshipPreferences}`,
    route: `/${mentee}/profile/mentorship-preferences`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.professionalBackground}`,
    route: `/${mentee}/profile/professional-background`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.cv}`,
    route: `/${mentee}/profile/cv`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.subscription}`,
    route: `/${mentee}/profile/subscription`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.mentoringAgreements}`,
    route: `/${mentee}/profile/mentoring-agreements`,
  },
  {
    label: `${myProfilePrefix} / ${copy.pages.profile.completedMentoringProgram}`,
    route: `/${mentee}/profile/completed-mentoring-programs`,
  },
  {
    label: `${copy.pages.profile.menteeDetails}`,
    route: `/social-profile/mentee/[menteeId]`,
  },
  {
    label: `${copy.pages.profile.mentorProfile}`,
    route: `/social-profile/mentor/[mentorId]`,
  },
  {
    label: `${copy.pages.mentoringPackages.mentoringPackages}`,
    route: `/${mentor}/mentoring-packages/new`,
  },
  {
    label: `${copy.pages.mentoringPackages.mentoringPackages}`,
    route: `/${mentor}/mentoring-packages/edit/[packageId]`,
  },
  {
    label: `${copy.pages.updatePassword.title}`,
    route: `/update-password`,
  },
  {
    label: `${copy.pages.dashboard.title}`,
    route: `/dashboard`,
  },
  {
    label: `${copy.pages.dashboard.title}`,
    route: `/dashboard/`,
  },
  {
    label: `${copy.pages.meetingRoom.title}`,
    route: `/meeting-room/[sessionId]`,
  },
  {
    label: `${copy.pages.groupCohorts.editCohort}`,
    route: `/${mentor}/group-mentoring-cohorts/edit/[cohortId]`,
  },
  {
    label: `${copy.pages.groupCohorts.title}`,
    route: `/group-cohorts/[cohortId]`,
  },
  {
    label: `${copy.pages.admin.title}`,
    route: `/admin`,
  },
  {
    label: `${copy.pages.admin.title}`,
    route: `/admin/[...]`,
  },
  {
    label: `${copy.pages.mentoringPackages.title}`,
    route: `/mentorship-packages/[...]`,
  },
];
